import Logo from "../../../assets/logo/logo-white.svg?react";
import { useIsUserSignedIn } from "../../../core_stores/useAuthStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { useAuthModal } from "../../../providers/AuthModalProvid";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";

export function WelcomeAppBar() {
  const isUserSignedIn = useIsUserSignedIn();
  const isCompactView = useIsCompactView();

  const { show: showAuthModal } = useAuthModal();

  async function onAuth() {
    await showAuthModal();
  }

  return (
    <div
      className={`${
        isCompactView ? "p-4" : "py-4 px-8"
      } z-30 w-full flex flex-row items-center justify-between`}
    >
      <a href="/" className="cursor-pointer">
        <Logo
          className={`${
            isCompactView ? "scale-[9]" : "scale-[11.5]"
          } origin-left z-20`}
        />
      </a>

      <div className="flex items-center gap-4">
        {((isCompactView && isUserSignedIn) || !isCompactView) && (
          <PricingBtn />
        )}
        {isUserSignedIn ? null : isCompactView ? (
          <SingleSignInBtn onSignIn={onAuth} />
        ) : (
          <SignInSignUpBtn onSignIn={onAuth} onSignUp={onAuth} />
        )}
      </div>
    </div>
  );
}

function SingleSignInBtn({ onSignIn }: { onSignIn?: () => void }) {
  return (
    <button
      id="home-sign-in"
      onClick={onSignIn}
      className="bg-primary-blue text-white font-[700] px-6 h-[34px] flex items-center justify-center rounded-full focus:outline-none hover:bg-blue-400 transition-colors text-base"
    >
      SIGN IN
    </button>
  );
}

function SignInSignUpBtn({
  onSignIn,
  onSignUp,
}: {
  onSignIn?: () => void;
  onSignUp?: () => void;
}) {
  return (
    <div className="flex h-9 w-[286px] rounded-full overflow-hidden shadow-md bg-black relative">
      <button
        id="home-sign-in"
        onClick={onSignIn}
        className="bg-black text-white font-[700] pl-10 pr-16 h-full flex items-center justify-center rounded-full focus:outline-none hover:bg-gray-800 transition-colors"
      >
        SIGN IN
      </button>
      <button
        id="home-sign-up"
        onClick={onSignUp}
        className="absolute right-0 bg-primary-blue text-white font-[700] px-8 h-full flex items-center justify-center rounded-full focus:outline-none hover:bg-blue-400 transition-colors text-base"
      >
        GET STARTED
      </button>
    </div>
  );
}

function PricingBtn() {
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  return (
    <button
      id="home-pricing"
      onClick={openSubscriptionsModal}
      className="bg-gradient-to-r from-fuchsia-500 to-violet-500 text-white font-[700] 
      px-6 h-9 flex items-center justify-center rounded-full 
      shadow-lg hover:brightness-110 hover:cursor-pointer transition-all"
    >
      PRICING
    </button>
  );
}
